/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { SessionTimeoutService } from './shared/session-timeout-modal/service/session-timeout.service';
import { LocalStorageService } from './shared/localStorage.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService,
    private seoService: SeoService,
    private sessionTimeoutService: SessionTimeoutService,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.sessionTimeoutService.checkTokenFailure();

    const loginSuccess = this.localStorageService.getItem('loginSuccess');
    if (loginSuccess) {
      this.sessionTimeoutService.sessionTimedOut();
    }
  }
}
